var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Btn",class:{ loading: _vm.loading }},[_vm._t("default"),(_vm.loading)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }